import type { SVGProps } from 'react';

export function SquaresArrowDownIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden {...props}>
      {/* Top-left — aligned with top-right */}
      <path d="M2 2.5A1.5 1.5 0 0 1 3.5 1h2A1.5 1.5 0 0 1 7 2.5v2A1.5 1.5 0 0 1 5.5 6h-2A1.5 1.5 0 0 1 2 4.5v-2Z" />
      {/* Bottom-left — lowered so its bottom lines up with the arrow tray */}
      <path d="M2 11.25A1.5 1.5 0 0 1 3.5 9.75h2A1.5 1.5 0 0 1 7 11.25v2A1.5 1.5 0 0 1 5.5 14.75h-2A1.5 1.5 0 0 1 2 13.25v-2Z" />
      {/* Top-right */}
      <path d="M11.5 1A1.5 1.5 0 0 0 10 2.5v2A1.5 1.5 0 0 0 11.5 6h2A1.5 1.5 0 0 0 15 4.5v-2A1.5 1.5 0 0 0 13.5 1h-2Z" />
      {/* Download arrow under top-right */}
      <g fill="none" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12.5 8.15v5.45" />
        <path d="M10.05 11.55 12.5 14l2.45-2.45" />
        <path d="M9.85 15.1h5.3" />
      </g>
    </svg>
  );
}
